import * as React from 'react'
import ReactPaginate from 'react-paginate'
import { PageLoader } from '../shared/loaders/PageLoader'
import { LayoutProps } from './settlementsState'
import {
  SettlementAttributeRenderWidgets,
  SettlementAttributesForColumn,
  SettlementDetails
} from './settlementsWidgets'

export const SettlementsOverviewLayout = (props: LayoutProps): JSX.Element => (
  <section className="page-section page-section--slim settlements--overview">
    <div id="settlements-top" />
    <header className="grid-100 page-section__head">
      <h1 className="page-section__title">OPP Settlements</h1>
    </header>

    {props.state.kind === 'overview' ? (
      <div id="overview" className="grid-100 table-wrapper">
        <table className="table--bordered index">
          <thead>
            <tr>
              <th>uid</th>
              {SettlementAttributesForColumn().map(x => (
                <th>{x}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.state.overview.settlements.map(settlement => (
              <tr key={settlement.uid}>
                <td style={{ verticalAlign: 'top' }}>
                  <button
                    className="btn"
                    onClick={() => {
                      if (!props.isExporting()) {
                        props.toggleSettlement(settlement)
                      }
                    }}
                  >
                    {settlement.uid}
                  </button>
                </td>
                {props.state.kind === 'overview' &&
                props.state.openSettlement.v.kind === 'r' &&
                props.state.openSettlement.v.v.uid === settlement.uid ? (
                  <td colSpan={SettlementAttributesForColumn().count()}>
                    <SettlementDetails
                      settlement={settlement}
                      onExportRequest={() =>
                        props.onSettlementExport(settlement)
                      }
                      isExportingSomething={() => props.isExporting()}
                      isExportingThis={() =>
                        props.isExportingSettlement(settlement)
                      }
                    />
                  </td>
                ) : (
                  <>
                    {SettlementAttributesForColumn().map(x => (
                      <td>
                        {SettlementAttributeRenderWidgets[x](settlement).run(
                          _ => null
                        )}
                      </td>
                    ))}
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="pagination--section">
          <ReactPaginate
            pageCount={props.state.overview.last_page}
            initialPage={props.state.overview.page - 1}
            pageRangeDisplayed={5}
            marginPagesDisplayed={2}
            containerClassName="pagination"
            nextLabel=""
            previousLabel=""
            onPageChange={i => {
              document.getElementById('settlements-top').scrollIntoView(false)
              props.onPageChange(i.selected + 1)
            }}
          />
        </div>
      </div>
    ) : props.state.overview.kind === 'loading' ? (
      <PageLoader />
    ) : (
      <>Something went wrong, try again later</>
    )}
  </section>
)
